import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '@/router';

/**
 * 应用根组件：挂载路由（AuthProvider 已在 main.tsx 包裹）。
 * 使用 BrowserRouter 支持 SPA 回退（生产由 Nginx try_files 兜底）。
 */
export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
